import { useAgegate } from 'hooks/use-agegate'
import { useSession } from 'contexts/session-context'
import { ComingSoonContainer, ComingSoonImage } from './style/custom.styles'
const ComingSoon = ({ children }: { children: JSX.Element[] }) => {
  const [session] = useSession()
  const { getAgeData, saveAgeData } = useAgegate();

  const logout = () => {
    const currentAgeGate = getAgeData();
    window.localStorage.clear()
    saveAgeData(currentAgeGate);
    window.location.href = `${process.env.PUBLIC_URL}/start`
  }

  if (THEME_CONFIG.comingSoon && session?.user?.id) {
    return (
      <ComingSoonContainer style={{ backgroundImage: `url('${AZURE_BASE_URL}/cs-background.svg')` }}>
        <div className='flex justify-end m-3'>
          <button onClick={logout} className=''>
            <img src={`${AZURE_BASE_URL}/cross.svg`} alt="icono cerrar" />
          </button>
        </div>
        <ComingSoonImage className='flex justify-center items-center mx-5'>
          <img src={`${AZURE_BASE_URL}/cs-image.svg`} alt="cartel" />
        </ComingSoonImage>
      </ComingSoonContainer>
    )
  }
  return <>{children}</>
}

export default ComingSoon
